import type { FileSystem, Writer } from '@playcanvas/splat-transform';

import { BrowserFileWriter } from './browser-file-system';

/**
 * FileSystem writing into a directory handle, creating subdirectories for
 * slash-separated names (multi-file exports such as LCC2).
 */
class DirectoryFileSystem implements FileSystem {
    private readonly root: FileSystemDirectoryHandle;

    constructor(root: FileSystemDirectoryHandle) {
        this.root = root;
    }

    private async directory(parts: string[]) {
        let dir = this.root;
        for (const part of parts) {
            if (part) dir = await dir.getDirectoryHandle(part, { create: true });
        }
        return dir;
    }

    async createWriter(filename: string): Promise<Writer> {
        const parts = filename.split('/');
        const name = parts.pop();
        const dir = await this.directory(parts);
        const handle = await dir.getFileHandle(name, { create: true });
        return new BrowserFileWriter(await handle.createWritable());
    }

    async mkdir(path: string): Promise<void> {
        await this.directory(path.split('/'));
    }
}

export { DirectoryFileSystem };
